export const PAGE_SIZE = 25;

export const getSkipLimit = (page) => ({
  skip: (page - 1) * PAGE_SIZE,
  limit: PAGE_SIZE
});

export const searchTypes = Object.freeze({
  name_id: {
    key: "name_id",
    maxLength: null,
    maskInput: ""
  },
  dob: {
    key: "dob",
    maxLength: 10,
    maskInput: "99/99/9999"
  },
  phone_number: {
    key: "phone_number",
    maxLength: 14,
    maskInput: "(999) 999-9999"
  },
  social_security_number: {
    key: "social_security_number",
    maxLength: 11,
    maskInput: "999-99-9999"
  }
});

export const ViewType = Object.freeze({
  List: { key: "list", value: (t) => t("main_view.list") },
  Calendar: { key: "calendar", value: (t) => t("main_view.calendar") },
  SavedList: { key: "savedLists", value: (t) => t("main_view.saved_list") }
});

export const INTERNAL_PROGRAM = "internal";
export const SAVED_LIST_PAGE_SIZE = 10;
